import type {ThesaurusId} from '../types';

const allThesaurusIds: ThesaurusId[] = [
  'genreandform',
  'bokbasen',
  'grep',
  'thema',
  'neo',
];

export const useAllThesaurusIds = (): ThesaurusId[] => allThesaurusIds;
